import React, { Component } from 'react'
import { Icon } from 'antd'
import { app, api, config } from "../../app"
import Card from "../../components/Card"
import '../../css/scancode.css'

class ScanCode extends Component {
    constructor (props) {
        super(props)
        let reqParam = {}
        let params = props.location.hash.split('#/')[1]
        params = params.split('&')
        for (let i = 0; i < params.length; i++) {
            let val = params[i].split('=')
            reqParam[val[0]] = decodeURI(val[1])
        }
        this.state = {
            reqParam,
            info: {
                teamname: [],
                rescue: [],
                train: [],
                leaveInfo: [],
            },
            res_msg: (<span>正在加载 <Icon type='loading'/></span>)
        }
    }

    componentDidMount () {
        document.getElementsByTagName('body')[0].style.width = window.screen.width + 'px'
        document.getElementById('root').style['min-width'] = '0px'
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    dataSource = async () => {
        let { reqParam } = this.state, params = {
            team_id: '00',
            indexno: reqParam.i,
            type: 1,
            time: reqParam.t,
        }, { flag, data, msg } = await app.post(api.UserInfo, params)
        let state = { res_flag: flag, res_msg: msg }
        if (flag === 1) {
            data.rescue = []
            data.train = []
            state.info = data
        }
        this.setState(state)
    }


    render () {
        let { res_flag, info, res_msg } = this.state
        return (
            <div className="player-info">
                {
                    res_flag === 1 ? (
                        <div>
                            <div className="info-1">
                                <div className="i1-1">
                                    <div
                                        className="names">{info.vname || '无'}（<span>{info.ppeid === '存心工作证' ? '已认证队员' : '未认证队员'}</span>）
                                    </div>
                                    <p className="item">所属分队：{
                                        info.teamname.map((t, i) => {
                                            return (
                                                <span key={i}>{t.teamname}</span>
                                            )
                                        })
                                    }</p>
                                    <p className="item">职务：{info.teampositionname || '无'}</p>
                                    <p className="item">存心编号：{info.bsrno}</p>
                                </div>
                                <div className="i1-2">
                                    <img src={config.imgUrl + app.urlEncode(info.localpath)} alt="暂无头像"/>
                                </div>
                            </div>
                            <div className="info-2">
                                <div className="title">基本信息</div>
                                <div className="content">
                                    <div className="item">
                                        <div>姓名</div>
                                        <div className="val">{info.vname || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>性别</div>
                                        <div className="val">{info.sex || '其他'}</div>
                                    </div>
                                    <div className="item">
                                        <div>出生年月</div>
                                        <div className="val">{info.birthdate || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>身份证号</div>
                                        <div className="val">{info.idno || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>护照号</div>
                                        <div className="val">{info.passport || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>血型</div>
                                        <div className="val">{info.bloodtype || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>过敏史</div>
                                        <div className="val">{info.drughis || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>重大医疗史</div>
                                        <div className="val">{info.medicalhis || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>手机</div>
                                        <div className="val">{info.mobile || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>入队时间</div>
                                        <div className="val">{info.indate || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>离队时间</div>
                                        <div className="val">{info.outdate || '无'}</div>
                                    </div>
                                    <div className="item">
                                        <div>最后认证时间</div>
                                        <div className="val">{info.rect || '无'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="info-5 info-3">
                                <div className="title">离队/清退 经历</div>
                                <div className="content">
                                    {
                                        info.leaveInfo.map((leave, index) =>
                                            (
                                                <div key={index}>
                                                    <div className="item">
                                                        <div>离队时间</div>
                                                        <div>{leave.outdate + " " + leave.leave_teamname}</div>
                                                    </div>
                                                    <div className="item">
                                                        <div>离队原因</div>
                                                        <div>{leave.leave_reason}</div>
                                                    </div>
                                                </div>
                                            )
                                        )
                                    }
                                    {
                                        info.volunteer_state === "5" ?
                                            (
                                                <div>
                                                    <div className="item">
                                                        <div>清退时间</div>
                                                        <div>{info.outdate || "无记录"}</div>
                                                    </div>
                                                    <div className="item">
                                                        <div>清退原因</div>
                                                        <div>{info.leave_reason || "无"}</div>
                                                    </div>
                                                </div>
                                            ) : null
                                    }
                                </div>
                            </div>
                            <div className="info-3">
                                <div className="title">最近救援经历</div>
                                <div className="content">
                                    {
                                        info.rescue.map((r, i) => {
                                            return (<div className="item" key={i}>
                                                <div>{r.rescuename}</div>
                                                <div>{r.startdate}</div>
                                            </div>)
                                        })
                                    }
                                </div>
                            </div>
                            <div className="info-4">
                                <div className="title">最近培训经历</div>
                                <div className="content">
                                    {
                                        info.train.map((t, i) => {
                                            return (
                                                <div key={i} className="item">
                                                    <div>{t.trainame}</div>
                                                    <div>{t.startdate}</div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            {
                                info.volunteer_state === '4' ? <div className='leave-kaichu-img leave-img'/> :
                                    (info.volunteer_state === '5' ?
                                        <div className='leave-kaichu-img kaichu-img'/> : null)
                            }
                        </div>
                    ) : (
                        <div className='no-msg'>{res_msg}</div>
                    )
                }
            </div>
        )
    }
}

export default ScanCode



// WEBPACK FOOTER //
// ./src/routes/other/ScanCode.jsx